// pages/report/index.tsx
import { useParams } from "react-router-dom";
import CampaignReport from "../views/marketing-pages/report";

export default function SMSCampaignReport() {
  const { id } = useParams<{ id: string }>();
  return <CampaignReport campaignId={id ?? ""} isExpanded />;
}